import type { CreateProductInput, UpdateProductInput } from '@financiar/shared';
import { apiClient } from '../../api/client';
import type { ListParams, Paginated, Product, VatRate } from '../../api/types';

export async function fetchProduse(params: ListParams & { companyId: string }): Promise<Paginated<Product>> {
  const { data } = await apiClient.get<Paginated<Product>>('/products', { params });
  return data;
}

export async function fetchProdus(id: string): Promise<Product> {
  const { data } = await apiClient.get<Product>(`/products/${id}`);
  return data;
}

export async function createProdus(input: CreateProductInput): Promise<Product> {
  const { data } = await apiClient.post<Product>('/products', input);
  return data;
}

export async function updateProdus(id: string, input: UpdateProductInput): Promise<Product> {
  const { data } = await apiClient.patch<Product>(`/products/${id}`, input);
  return data;
}

export async function deleteProdus(id: string): Promise<void> {
  await apiClient.delete(`/products/${id}`);
}

/** `GET /vat-rates` — the currently-effective rate per VAT category. Called
 * with no `?date`, so the API resolves it against "today". Cached for an
 * hour by the callers' `useQuery({ staleTime })` — this almost never
 * changes, and re-fetching it on every products page visit would be waste. */
export async function fetchVatRates(): Promise<VatRate[]> {
  const { data } = await apiClient.get<VatRate[]>('/vat-rates');
  return data;
}
